import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import {GetAutomaticPricingForPurchases} from '../queries';
import {
    type GetAutomaticPricingForPurchasesQueryVariables,
    type GetAutomaticPricingForPurchasesQuery,
} from '../__generated__/queries.api-types';

export type AutomaticPricing = {
    childId: string;
    ruleGroups: Array<RuleGroup>;
};
type RuleGroup = {
    ruleGroupId: string;
    pricing: Array<Pricing>;
};
export type Pricing = {
    pricingGroupId: string;
    dates: {
        from: string;
        to: null | undefined | string;
    };
};

export const useGetAutomaticPricingForPurchases = (institutionId: string, childIds: Array<string>) => {
    const [automaticPricingForPurchasesData] = useTransformQuery<
        GetAutomaticPricingForPurchasesQuery,
        GetAutomaticPricingForPurchasesQueryVariables
    >()(
        GetAutomaticPricingForPurchases,
        {
            variables: {
                siteId: institutionId,
                childIds,
            },
            skip: !institutionId || !childIds.length,
            fetchPolicy: 'network-only',
        },
        ({data, loading}): {loading: boolean; automaticPricing: Array<AutomaticPricing>} => {
            if (loading || !hasValue(data)) {
                return {
                    loading,
                    automaticPricing: [],
                };
            }

            const automaticPricing = data.finance.purchases.automaticPricing.children.map(({childId, ruleGroups}) => ({
                childId,
                ruleGroups: ruleGroups.map(({ruleGroupId, pricing}) => ({
                    ruleGroupId,
                    pricing: pricing.map(pricing => ({
                        pricingGroupId: pricing.pricingGroupId,
                        dates: {
                            from: pricing.dates.from,
                            to: pricing.dates.to,
                        },
                    })),
                })),
            }));

            return {
                loading: false,
                automaticPricing,
            };
        },
    );

    return {automaticPricingForPurchasesData};
};
